<template>
  <div>
    <div class="wapper">
      <header>
        <el-date-picker size="mini" v-model="expiryDate" type="date" value-format="yyyyMMdd" placeholder="选择日期" :picker-options="pickerOptions" @change="expiryDateChange" style="margin-left: 5px;">
        </el-date-picker>
        <el-button size="small" @click="$router.push('/')" style="margin-left: 5px;"> 返回商品交易界面 </el-button>
        <el-button @click="downPdf" style="float: right;" size="mini">导出</el-button>
        <el-button type="danger" style="float: right;margin-right: 5px" @click="dialogVisible = true" size="mini"> 导出说明
        </el-button>
      </header>
      <div id="diff-pdf">
        <p class="pdf-title">{{companyName}}-价差期权报价</p>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <h3 style="color: #e96900">请使用最新版的谷歌(chrome)或者qq,360浏览器</h3>
      <p>点击导出,打开更多设置,修改左侧参数,如下图所示</p>
      <div>
        <img src="../public/geshi.png" width="100%">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import diffSocket from '@/components/home/diffSocket'
  import g from '@/components/Global'
  export default {
    data() {
      return {
        dialogVisible: false,
        expiryDate: '',
        pickerOptions: {
          disabledDate: date => {
            return date.getDay() === 0 || date.getDay() === 6 || this.timeFormat(date) < this.minDays || this.$store.state.restDayStore.indexOf(Number(this.timeFormat(date))) !== -1
          }
        },
      }
    },
    created() {
      this.expiryDate = window.sessionStorage.getItem("expiryDate")
    },
    destroyed() {
      
    },
    methods: {
      expiryDateChange(date) {

      },
      downPdf() {
        document.title = 'NhCapital' + this.nowDate;
        document.getElementById("diff-pdf").style.display = "none";
        window.print();
        document.title = 'NhCapital'
        document.getElementById("diff-pdf").style.display = "block";
      },
    },
    computed: {
      companyName() {
        return this.$store.getters.gsName
      },
    },
    watch: {
      $route: {
        handler(to, from) {

        },
        immediate: true,
      }
    },
    components: {
      diffSocket,
    },
  }
</script>

<style scoped>
.wapper {
  width: 1000px;
  margin: 0 auto;
}
.wapper header {
  margin-top: 5px;
}

#diff-pdf {
  margin-top: 10px;
}
#diff-pdf .pdf-title {
  text-align: center;
  color: #fff;
  background: #1f4e78;
  font-size: 18px;
  font-weight: 900;
}
</style>